<template>
    <a-modal 
             :loading="isLoading"
             :visible="isVisible"
             :closable="false"
             width="400px"
    >
        <template slot="footer">
            <a-button key="back" @click="handleCancel" v-show="isReady" icon="close">
                Close
            </a-button>
            <a-button @click="handleView" v-show="isReady" :disabled="!isConfirmed" icon="search">
                View
            </a-button>
            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handleReady">
                <template slot="title">
                    <p>Is the order ready?</p>
                </template>
                <a-button type="primary" v-show="isReady&&isSetReady" icon="check">
                    Set Ready
                </a-button>
            </a-popconfirm>
            
        </template>
        <a-row type="flex" justify="start" class="icons-list">
             <a-col :flex="2">
                <a-icon :type="icon" />
            </a-col>
            <a-col :flex="2">
                <p>{{ message }}</p>
            </a-col>
        </a-row>

        <a-row type="flex" justify="start" class="icons-list" v-show="!isReady">
           
            <a-col :flex="3" justify="center">
                <a-progress :percent="progress" size="small" status="active" :showInfo="false"/> 
            </a-col> 
        </a-row>
      
        <br/>
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
            isLoading : false,
            isVisible : false,
            isReady : false,
            isConfirmed : false,
            isSetReady : false,
            message : '',
            icon : 'loading',
            progress : 100,
            orderId : '',
            order : null,
        }
    },
    methods : {
        
        showModalToWait() {
            this.message = 'Looking for order';
            this.isVisible = true;     
            this.icon = 'loading';   
            this.isConfirmed =false; 
        },

        showModalToConfirm(e) {
            this.reset();
            this.order = e;
            
            this.isVisible = true;
            this.message = "OrderId: " + this.order.orderId + " is found"
            this.icon = 'check';
            this.isReady = true;
            this.isConfirmed = true;
            if(this.order.state === 4 || this.order.state === 1) {
                this.isSetReady = true;
            }
        },

        handleCancel() {
            this.isVisible = false;
        },

        handleReady() {
            this.isVisible = false;
            this.$emit('setReadyOrderEvent', this.order);
        },

        handleView() {
            this.isVisible = false;
            this.$emit('viewOrderEvent', this.order);
        },

        reset() {
            this.isLoading = false;
            this.isVisible = false;
            this.isReady = false;
            this.isConfirmed = false;
            this.isSetReady = false;
        }
        
    }
}
</script>

<style scoped>
</style>